module.exports = __webpack_public_path__ + "img/world.a57511c4.svg";